import type { RosterRow } from '../Roster/rosterRows';
import { buildSchoolRows, type SchoolRow } from './schoolRows';

export function findSchoolDetail(rows: RosterRow[], name: string): SchoolRow | null {
  const key = name.trim().toLowerCase();
  if (key === '') return null;
  return buildSchoolRows(rows).find((row) => row.name.trim().toLowerCase() === key) ?? null;
}
